import React from "react";
import { Alert, Button } from "reactstrap";

const FormFooter = ({
  result,
  submitBlockers,
  resetForm,
  isSubmitting,
  isValidatingIdentity,
  isCreateDisabled,
}) => (
  <>
    {!!result.message && (
      <div className={`alert alert-${result.type}`} role="alert">
        {result.message}
      </div>
    )}

    {!!submitBlockers.length && (
      <Alert color="warning" className="my-3">
        <strong>Antes de crear:</strong>
        <ul className="mb-0 mt-2 pl-3">
          {submitBlockers.map((blocker, index) => (
            <li key={`${blocker}-${index}`}>{blocker}</li>
          ))}
        </ul>
      </Alert>
    )}

    <div className="d-flex justify-content-between mt-4 prereg-actions">
      <Button
        color="light"
        type="button"
        onClick={resetForm}
        disabled={isSubmitting || isValidatingIdentity}
      >
        <i className="fa fa-refresh mr-1" aria-hidden="true"></i>
        Reiniciar formulario
      </Button>

      <div className="prereg-actions-main">
        <Button
          color="primary"
          disabled={isCreateDisabled}
        >
          <i
            className={`fa ${isSubmitting ? "fa-spinner fa-spin" : "fa-paper-plane"} mr-1`}
            aria-hidden="true"
          ></i>
          {isSubmitting ? "Enviando..." : "Crear"}
        </Button>
      </div>
    </div>
  </>
);

export default FormFooter;
